import { memo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { SIDEBAR } from "./constants/Sidebar.constants";
import "./sidebar.scss";

const Sidebar = () => {
  const { t } = useTranslation();
  // const { t, i18n } = useTranslation();

  let location = useLocation();

  const [navbarCollapse, setNavbarCollapse] = useState(false);

  // const handlChangeLanguage = (e) => {
  //   i18n.changeLanguage(e.target.value);
  // };

  return (
    <nav id="navbar" className="navbar navbar-expand-lg">
      <div className="container">
        <Link to="/home" className="navbar-brand">
          <div className="repair">
            <img src="/images/gif/wrench.gif" alt="repair" />
          </div>
          <img src="/logo.png" alt="logo" style={{ height: "50px" }} />
        </Link>
        <button
          type="button"
          className="btn navbar-toggler"
          onClick={() => setNavbarCollapse(!navbarCollapse)}
        >
          <svg
            width="20"
            height="12"
            viewBox="0 0 20 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="20" height="2" rx="1" fill="black" />
            <rect y="5" width="20" height="2" rx="1" fill="black" />
            <rect y="10" width="20" height="2" rx="1" fill="black" />
          </svg>
        </button>
        <div
          className={
            navbarCollapse
              ? "collapse navbar-collapse show"
              : "collapse navbar-collapse"
          }
        >
          <ul className="navbar-nav">
            {SIDEBAR.map((link) => {
              return (
                <li className="nav-item" key={link.id}>
                  <Link
                    to={link.path}
                    className={
                      location.pathname === link.path
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    {t(`NAVBAR.${link.name}`)}
                  </Link>
                </li>
              );
            })}
            {/* <li className={"nav-item d-flex justify-content-center"}>
                            <select className={"form-control"} onChange={handlChangeLanguage} defaultValue={localStorage.getItem("i18nextLng") ? localStorage.getItem("i18nextLng") : "en"}>
                                <option value={"uz"}>Uz</option>
                                <option value={"ru"}>Ru</option>
                                <option value={"en"}>En</option>
                            </select>
                        </li> */}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default memo(Sidebar);
